import { z } from 'zod';
import { LogoSchema, imageSchema } from './image-schema';
import { metaSchema } from './meta-schema';

export type TPerson = z.infer<typeof personSchema>;

export const personSchema = z.object({
  id: z.number(),
  attributes: z.object({
    name: z.string(),
    title: z.string(),
    companyName: z.string().optional(),
    subtitle: z.string().optional().nullable(),
    phone: z.string().optional().nullable(),
    email: z.string().optional().nullable(),
    website: z.string().optional().nullable(),
    background: imageSchema,
    logo: LogoSchema.optional(),
    icon: imageSchema,
    center: imageSchema,
    meta: metaSchema,
  }),
});
